import * as z from "zod/v4";

const ExternalLocationSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  active: z.boolean(),
});

export const getQbLocations = {
  name: "getQbLocations" as const,
  input: z.null(),
  output: z.object({ locations: z.array(ExternalLocationSchema_) }),
};
